import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseApi, BASE_URL } from "@edl-development/edl-common";
import { CplUserCycleDetails } from "../model/cpl-user-cycle-details.model";

@Injectable()
export class UserCycleApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getUserCycleDetails(userCycleId: string) {
        return this.http.get<CplUserCycleDetails>(this.baseUri + '/UserCycleDetails/' + userCycleId);
    }

    updateFlexHoursForUserCycle(cplItemId: string, cycleId: string, hours: number ) {
        return this.http.post(this.baseUri + `/timetracking/update/${cycleId}`, { ItemID: cplItemId, Hours: hours });
    }
}